<!-- @veltra/icons generated sha256:354c2c8818d1f22f gen:8 source:src/svg/normal/user-add.svg -->
<script setup lang="ts">
defineOptions({ name: 'UserAdd' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M11.5 5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-6 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M8 10.5c.986 0 1.945.112 2.867.324a.514.514 0 0 0 .633-.49.49.49 0 0 0-.373-.476A13.8 13.8 0 0 0 8 9.5c-2.133 0-4.15.487-5.963 1.353a.96.96 0 0 0-.537.872V14a.5.5 0 0 0 .5.5h7c.277 0 .5-.228.5-.496a.51.51 0 0 0-.509-.504H2.5v-1.76A12.8 12.8 0 0 1 8 10.5m4.75 4.993V13.75h-1.743a.51.51 0 0 1-.507-.496.51.51 0 0 1 .507-.504h1.743v-1.743c0-.276.228-.507.496-.507a.51.51 0 0 1 .504.507v1.743h1.743c.276 0 .507.228.507.496a.51.51 0 0 1-.507.504H13.75v1.743a.51.51 0 0 1-.496.507.51.51 0 0 1-.504-.507"
    />
  </svg>
</template>
